import React from 'react';
import { useNavigate } from 'react-router';

import { useTranslation } from '@common/hooks/translation';
import { getBannerContentPositionName, getBannerImageUrl } from '@app/dev/helpers/banners';

export const CompItemRemote = ({ link, redirectUrl, text, icon, iconPosition }) => {
  const t = useTranslation();
  const navigate = useNavigate();

  const isExternal = redirectUrl?.startsWith('http');

  const onNavigate = () => {
    if (!redirectUrl) return;
    if (isExternal) {
      window.open(redirectUrl, '_self');
    } else {
      navigate(redirectUrl);
    }
  };

  const hasText = Boolean(text);
  const positionClass = `home-icon-pos-${getBannerContentPositionName(iconPosition, hasText)}`;

  return (
    <div
      className={`home-comp-item ${positionClass}`}
      onClick={redirectUrl ? onNavigate : undefined}
      style={{
        background: `url('${getBannerImageUrl(link)}') center/contain no-repeat`,
        cursor: redirectUrl ? 'pointer' : 'default',
      }}
    >
      <p className="layer" />
      {icon && <img src={`data:image/png;base64,${icon}`} alt="" className="home-comp-item-icon" />}
      {text && <span className="home-comp-item-text">{t(text)}</span>}
    </div>
  );
};
